function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4 13.71v116.08A10.08 10.08 0 0013.51 140a9.82 9.82 0 006.31-2l1.39-1 74.26-55.21 2.19-1.64a9.67 9.67 0 00-.07-16.19l-2.11-1.59-74-55.05C18.4 4.79 14.57 2.94 10.11 4.9A10.55 10.55 0 004 14.55v.78"
});

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 106 144",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgPlay;